import { usageTracker } from 'portals-platform-lib';
export function trackPortalInteraction(action, properties = {}) {
  usageTracker.track('Deal Plan Portal', 'Portal Interacted', Object.assign({
    action,
    screen: 'deal-plan-portal'
  }, properties));
}